import { forwardRef } from 'react';
import { WithErrorsContent } from './components/WithErrorsContent';
import { InfoPopover } from 'components/InfoPopover/InfoPopover';
import { InvoiceDiscrepancy } from 'services/invoiceDiscrepancies/types';

type DiscrepanciesModalProps = {
  style?: React.CSSProperties;
  error: InvoiceDiscrepancy | undefined;
  numberOfErrors: number;
};

export const DiscrepanciesModal = forwardRef<HTMLDivElement, DiscrepanciesModalProps>(
  ({ style, error, numberOfErrors }, ref) => {
    if (!error) {
      return null;
    }
    return (
      <InfoPopover ref={ref} style={style}>
        <WithErrorsContent error={error} numberOfErrors={numberOfErrors} />
      </InfoPopover>
    );
  },
);

DiscrepanciesModal.displayName = 'DiscrepanciesModal';
